// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__bC2Oz","small":"search_small__MBN3e","high":"search_high__q_Kw5"};